import store from '@/store'

import { ref, shallowRef, watch } from '@vue/composition-api'
import { formatOptions, formatStatusOptions, formatCountryOptions } from '@core/utils'

const selectedItem = ref(null)
const activeFilters = ref({ 
    conditions: [],   
    filter_id: null   
})
const projectData = ref({})
const analysisData = ref({})
const heatmapData = shallowRef([])
const savedFilters = ref([])
const allQuotas = ref([])


export default function useProjectEye() {
    const allCrosstabs = ref([])
    const rawSegments = ref([])
    const projectsData = ref([])
    const projectLoading = ref(false)
    const totalProjects = ref(0)
    const options = ref({
    sortBy: ['id'],
    sortDesc: [true],
    itemsPerPage: 10 //parseInt(process.env.VUE_APP_ITEMS_PER_PAGE)
  })

    const oculisProjectSearch = ref('')
    const projectCreationLoading = ref(false)

    const decipherProjectsData = ref([])
    const decipherProjectLoading = ref(false)
    const lighthouseProjectLoading = ref(false)

    const medias = ref([])
    const mediaData = ref({})
    const mediasLoading = ref(false)

    const fixationsLoading = ref(false)
    const filterLoading = ref(false)

    const aoiLoading = ref(false)
    const elementsLoading = ref(false)
    const elementsOptions = ref([])
    const netLoading = ref(false)

    const heatmapLoading = ref(false)

    const netAnalysisData = ref([])
    const summaryAnalysisData = ref({})
    const analysisLoading = ref(false)

    const comparisonAnalysisData = ref({})
    const comparisonLoading = ref(false)

    
    const typeItems = [{text: "Shelf", value: 1}, {text: "Pack", value: 2}]
    const sourceItems = [{text: "Eyeflow", value: 1}, {text: "MET", value: 2}, {text: "Static", value: 3}]



    // --- Color Palette for automatic selection ---
    const colorPalette = [
        '#FF6347', // Tomato
        '#4682B4', // SteelBlue
        '#32CD32', // LimeGreen
        '#FFD700', // Gold
        '#8A2BE2', // BlueViolet
        '#FF69B4', // HotPink
        '#00CED1', // DarkTurquoise
        '#FF4500', // OrangeRed
        '#ADFF2F', // GreenYellow
        '#BA55D3', // MediumOrchid
    ];

    const nextColorIndex = ref(0); // Index for the next color in the palette

    const getNextColor = () => {
        const color = colorPalette[nextColorIndex.value];
        nextColorIndex.value = (nextColorIndex.value + 1) % colorPalette.length; // Cycle through colors
        return color;
    };

    

    const generateGroupId = () => {
        return Math.random().toString(36).substring(2, 15);
    }

     // fetch data
    const fetchDecipherProjects = async (params) => {
        decipherProjectLoading.value = true
        await store
        .dispatch('app-oculis/fetchDecipherProjects', params)
        .then(response => {
            const { data } = response
            decipherProjectsData.value = data
            decipherProjectLoading.value = false

        })
        .catch(error => {
            console.log(error)
            decipherProjectLoading.value = false
        })
    }

     // add data
    const addProject = async (payload) => {
        projectCreationLoading.value = true
        return await store
        .dispatch('app-oculis/addProject', payload)
        .then(response => {
            const { data } = response
            projectData.value = data
            projectCreationLoading.value = false
            store.commit('comp-alert/SET_MESSAGE', {})
            return response

        })
        .catch(error => {
            console.log(error)
            projectCreationLoading.value = false
            return error
        })
    }
     // fetch data
    const updateProject = async (payload) => {
        projectCreationLoading.value = true
        return await store
        .dispatch('app-oculis/updateProject', payload)
        .then(response => {
            const { data } = response
            projectData.value = data
            projectCreationLoading.value = false
            store.commit('comp-alert/SET_MESSAGE', {})
            return response

        })
        .catch(error => {
            console.log(error)
            projectCreationLoading.value = false
            return error
        })
    }
    
    const updateMedia = async (payload) => {
        mediasLoading.value = true
        return await store
        .dispatch('app-oculis/updateMedia', payload)
        .then(response => {
            const { data } = response
            mediaData.value = data
            mediasLoading.value = false
            store.commit('comp-alert/SET_MESSAGE', {})
            return response

        })
        .catch(error => {
            console.log(error)
            mediasLoading.value = false
            return error
        })
    }

    const fetchOculisProject = async (params) => {
        projectLoading.value = true
        await store
        .dispatch('app-oculis/fetchOculisProject', params)
        .then(response => {
            const { data } = response
            projectData.value = data
            projectLoading.value = false

        })
        .catch(error => {
            console.log(error)
            projectLoading.value = false
        })
    }


     // fetch data
    const fetchOculisProjects = async () => {
        projectLoading.value = true
        await store
        .dispatch('app-oculis/fetchOculisProjects', {
            options: options.value,
            page:options.value.page,
            search: oculisProjectSearch.value
        })
        .then(response => {
            const { results, count, total_pages } = response.data
            projectsData.value = results
            totalProjects.value = count
            projectLoading.value = false

        })
        .catch(error => {
            console.log(error)
            projectLoading.value = false
        })
    }
    

    watch([options], () => {
        projectLoading.value = true
        projectsData.value = []
        fetchOculisProjects()
    })

    watch(oculisProjectSearch, (newVal, oldVal) => {
        if (newVal !== null){
            if (newVal.length >= 3) {
                options.value.page = 1
                fetchOculisProjects()
            }
            if(newVal.length == 0) fetchOculisProjects()
        }
    })
        

     // fetch data
    const fetchMediaHeatmap = async (project, media) => {
        const mediaParams = { project, media }
        if (activeFilters.value.conditions && activeFilters.value.conditions.length > 0) {
            mediaParams.conditions = activeFilters.value.conditions
        }
        heatmapLoading.value = true
        await store
        .dispatch('app-oculis/fetchMediaHeatmap', mediaParams)
        .then(response => {
            const { data } = response
            heatmapData.value = data
            heatmapLoading.value = false

        })
        .catch(error => {
            console.log(error)
            heatmapLoading.value = false
        })
    }

     // fetch data
    const fetchMediaAnalysis = async (project, media, time_slots='1,2,3,4,Full') => {
        
        const mediaParams = { project, media, time_slots, ...activeFilters.value }
        // Clean out empty conditions
        if (!mediaParams.conditions || mediaParams.conditions.length === 0) {
            delete mediaParams.conditions
        }
        analysisLoading.value = true
        netAnalysisData.value = [] 
        summaryAnalysisData.value = {}

        await store
        .dispatch('app-oculis/fetchMediaAnalysis', mediaParams)
        .then(response => {
            const { data } = response
            analysisData.value = data['data']
            summaryAnalysisData.value = data['summary']

            Object.entries(data).forEach(([key, val]) => {
                if (val.meta && val.meta.type === 'net') {
                    netAnalysisData.value.push({
                        id: generateGroupId(),
                        name: val.meta.name,
                        aois: val.meta.children 
                    });
                }
            });
            
            analysisLoading.value = false

        })
        .catch(error => {
            console.log(error)
            analysisLoading.value = false
        })
    }
    
    
    const downloadKPIAnalysis  = async (project) => {
        
        const mediaParams = { project, ...activeFilters.value }
        // Clean out empty conditions
        if (!mediaParams.conditions || mediaParams.conditions.length === 0) {
            delete mediaParams.conditions
        }
        store
        .dispatch('app-oculis/downloadKPIAnalysis', mediaParams)
        .then(response => {
            const { data } = response
            let fileURL = window.URL.createObjectURL(new Blob([data]));
            let fileLink = document.createElement('a');
        
            fileLink.href = fileURL;
            fileLink.setAttribute('download', `${project.job_number}_${project.country}_KPI Analysis.xlsx`);
            document.body.appendChild(fileLink);
        
            fileLink.click();

        })
        .catch(error => {
            // store.commit('app/LOADING', false)
            console.log(error.response)
            store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })
    }
    

    
     // fetch data
    const fetchMediaComparisonAnalysis = async (project, medias) => {
        const mediaParams = {
            project,
            queryParams:{
                media_ids:medias,
                time_slots:"full"
            }
        }
        if (activeFilters.value.conditions && activeFilters.value.conditions.length > 0) {
            mediaParams.queryParams.conditions = activeFilters.value.conditions
        }
        comparisonLoading.value = true;
        await store
        .dispatch('app-oculis/fetchMediaComparisonAnalysis', mediaParams)
        .then(response => {
            const { data } = response
            comparisonAnalysisData.value = data
            comparisonLoading.value = false;

        })
        .catch(error => {
            console.log(error)
            comparisonLoading.value = false;
        })
    }

    
    // fetch data
    const fetchAOIElements = async (project) => {
        elementsLoading.value = true
        await store
        .dispatch('app-oculis/fetchAOIElements', project)
        .then(response => {
            const { data } = response

            elementsLoading.value = false
            elementsOptions.value = data

        })
        .catch(error => {
            console.log(error)
            elementsLoading.value = false
        })
    }

    
    const fetchMediasAOIs = async (project) => {
        mediasLoading.value = true
        await store
        .dispatch('app-oculis/fetchMediasAOIs', project)
        .then(response => {
            const { data } = response

            mediasLoading.value = false
            medias.value = data

        })
        .catch(error => {
            console.log(error)
            mediasLoading.value = false
        })
    }

    
    
    // fetch data
    const fetchMedia = async (media) => {
        mediasLoading.value = true
        await store
        .dispatch('app-oculis/fetchMedia', media)
        .then(response => {
            const { data } = response

            data.aois.forEach(aoi => {
                const processedCoord = processCoordinates(aoi.shape, aoi.coordinates)
                delete aoi['coordinates']
                aoi['color'] = getNextColor()
                aoi['opacity'] = 0.5
                Object.entries(processedCoord).forEach(([key, value]) => {
                    aoi[key] = value
                })
            })
            mediasLoading.value = false
            mediaData.value = data

        })
        .catch(error => {
            console.log(error)
            mediasLoading.value = false
        })
    }

    const bulkCreateAOIs = async (payload) => {
        aoiLoading.value = true
        return await store
        .dispatch('app-oculis/bulkCreateAOIs', payload)
        .then(response => {
            const { aois, nets } = response.data
             Object.entries(aois).forEach(([aoi_key, aois]) => {
                const processedCoord = processCoordinates(aois.shape, aois.coordinates)
                delete aois['coordinates']
                aois['color'] = aois['color']
                aois['opacity'] = 0.5
                Object.entries(processedCoord).forEach(([key, value]) => {
                    aois[key] = value
                })
            })
            aoiLoading.value = false

            return {aois, nets}

        })
        .catch(error => {
            aoiLoading.value = false
            console.log(error)
        })
    }

    const addAOI = async (payload) => {
        aoiLoading.value = true
        return await store
        .dispatch('app-oculis/addAOI', payload)
        .then(response => {
            const { data } = response
            const processedCoord = processCoordinates(data.shape, data.coordinates)
            delete data['coordinates']
            data['color'] = payload['color']
            data['opacity'] = 0.5
            Object.entries(processedCoord).forEach(([key, value]) => {
                data[key] = value
            })
            aoiLoading.value = false

            return data

        })
        .catch(error => {
            aoiLoading.value = false
            console.log(error)
        })
    }
    const updateAOI = async (payload) => {
        aoiLoading.value = true
        await store
        .dispatch('app-oculis/updateAOI', payload)
        .then(response => {
            const { data } = response
            aoiLoading.value = false

        })
        .catch(error => {
            aoiLoading.value = false
            console.log(error)
        })
    }

    const deleteAOI = async (payload) => {
        aoiLoading.value = true
        await store
        .dispatch('app-oculis/deleteAOI', payload)
        .then(response => {
            aoiLoading.value = false

        })
        .catch(error => {
            aoiLoading.value = false
            console.log(error)
        })
    }

    const addNet = async (payload) => {
        netLoading.value = true
        return await store
        .dispatch('app-oculis/addNet', payload)
        .then(response => {
            const { data } = response
            netLoading.value = false

            return data

        })
        .catch(error => {
            netLoading.value = false
            console.log(error)
        })
    }
    const updateNet = async (payload) => {
        netLoading.value = true
        await store
        .dispatch('app-oculis/updateNet', payload)
        .then(response => {
            const { data } = response
            netLoading.value = false

        })
        .catch(error => {
            netLoading.value = false
            console.log(error)
        })
    }

    const deleteNet = async (payload) => {
        netLoading.value = true
        await store
        .dispatch('app-oculis/deleteNet', payload)
        .then(response => {
            netLoading.value = false

        })
        .catch(error => {
            netLoading.value = false
            console.log(error)
        })
    }

    const processCoordinates = (shapeType, coords) => {
        if (!Array.isArray(coords) || coords.length === 0) {
            console.error("Coordinates input must be a non-empty array.");
            return null;
        }

        switch (shapeType.toLowerCase()) {
            case 'rectangle': {
            if (coords.length !== 4) {
                console.error("Rectangle requires exactly 4 coordinates.");
                return null;
            }
            const [x, y, x2, y2] = coords;
            const width = Math.abs(x2 - x);
            const height = Math.abs(y2 - y);

            return {
                x,
                y,
                width,
                height
            };
            }

            case 'circle': {
            if (coords.length !== 3) {
                console.error("Circle requires exactly 3 coordinates (x, y, radius).");
                return null;
            }
            const [x, y, radius] = coords;
            return {
                x,
                y,
                radius
            };
            }

            case 'polygon': {
                // Polygons require an even number of coordinates (at least 3 points/6 coords)
                if (coords.length % 2 !== 0 || coords.length < 6) {
                    console.error("Polygon requires an even number of coordinates (at least 3 points).");
                    return null;
                }
                const points = [];
                for (let i = 0; i < coords.length; i += 2) {
                    points.push({ x: coords[i], y: coords[i + 1] });
                }
                return {
                    points: points
                };
            }

            default:
            console.error(`Unknown shape type: ${shapeType}`);
            return null;
        }
    }

    const addMedia = async (id, file) => {
        const payload = {
        id: id,
        name: file.name, 
        file: file,
        }
        mediasLoading.value = true
        return await store
        .dispatch('app-oculis/addMedia', payload)
        .then(response => {
            const { data } = response
            mediasLoading.value = false
            return data

        })
        .catch(error => {
        mediasLoading.value = false
            // store.commit('app/LOADING', false)
            console.log(error)
            // store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })

    }

    const addFixations = async (id, file) => {
        const payload = {
        id: id,
        file: file,
        }
        fixationsLoading.value = true
        return await store
        .dispatch('app-oculis/addFixations', payload)
        .then(response => {
            const { data } = response
            fixationsLoading.value = false
            return data

        })
        .catch(error => {
        fixationsLoading.value = false
            // store.commit('app/LOADING', false)
            console.log(error)
            // store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })

    }
    
    const deleteFixations = async (id) => {
        fixationsLoading.value = true
        return await store
        .dispatch('app-oculis/deleteFixations', id)
        .then(response => {
            const { data } = response
            fixationsLoading.value = false
            return data

        })
        .catch(error => {
        fixationsLoading.value = false
            // store.commit('app/LOADING', false)
            console.log(error)
            // store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })

    }

     const deleteMedia = async (id) => {
        mediasLoading.value = true
        return await store
        .dispatch('app-oculis/deleteMedia', id)
        .then(response => {
            const { data } = response
            mediasLoading.value = false
            return data

        })
        .catch(error => {
            mediasLoading.value = false
            // store.commit('app/LOADING', false)
            console.log(error)
            // store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })

    }

    // New State for Filters and Individual Data
    const filterOptions = ref([]) // Dropdown options from Decipher
    const scanpathData = shallowRef(null) // Scanpath data for specific user
    const scanpathLoading = ref(false)


    const fetchFilterOptions = async (projectId) => {
        filterLoading.value = true
        store.commit('app/LOADING', true)
        try {
            const response = await store.dispatch('app-oculis/fetchProjectCrosstabs', projectId)
            const { crosstabs, quotas } = response.data 
    
            const prepareGroups = (list, type) => {
                const uniqueGroups = []
                const seenTitles = new Set()
            
                list.forEach(group => {
                    if (group.title && !seenTitles.has(group.title)) {
                        uniqueGroups.push({
                            id: `${type}_${group.title}`, 
                            title: group.title,
                            type: type,
                            segments: (group.segments || []).map(s => ({
                                id: s.id,      
                                logic: s.cond, 
                                name: s.title, 
                                parentTitle: group.title,
                                source: type
                            }))
                        })
                        seenTitles.add(group.title)
                    }
                })
                return uniqueGroups
            }
    
            allCrosstabs.value = prepareGroups(crosstabs, 'crosstab')
            allQuotas.value = prepareGroups(quotas, 'quota')
       
        } catch (error) {
            console.error("Failed to fetch filters:", error)
        } finally {
            store.commit('app/LOADING', false)
            filterLoading.value = false

        }
    }
    

    const fetchSavedFilters = async (projectId) => {
        filterLoading.value = true
        try {
            const response = await store.dispatch('app-oculis/fetchSavedFilters', projectId)
            savedFilters.value = response.data
        } finally {
            filterLoading.value = false
        }
    }

    const saveFilter = async (projectId, payload) => {
        await store.dispatch('app-oculis/saveFilter', { projectId, payload })
        await fetchSavedFilters(projectId)
    }

    const deleteFilter = async (projectId, filterId) => {
        await store.dispatch('app-oculis/deleteFilter', { projectId, filterId })
        const response = await store.dispatch('app-oculis/fetchSavedFilters', projectId)
        savedFilters.value = response.data
    }
    
    const renameFilter = async (projectId, filterId, newName) => {
        await store.dispatch('app-oculis/updateFilter', { projectId, filterId, payload: { name: newName } })
        const response = await store.dispatch('app-oculis/fetchSavedFilters', projectId)
        savedFilters.value = response.data
    }

    const applyAnalysis = async (projectId, mediaId, payload) => {
        if (!payload.conditions || payload.conditions.length === 0) {
            delete payload.conditions
        }
        activeFilters.value = payload

        if (projectId) {
            analysisLoading.value = true
            heatmapLoading.value = true
            
            try {
    
                await fetchOculisProject({ 
                    project: projectId, 
                    ...payload 
                });
    
                if (mediaId) {
                    await fetchMediaAnalysis(projectId, mediaId);
                    await fetchMediaHeatmap(projectId, mediaId);
                }
                
            } catch (error) {
                console.error("Filter application failed", error);
            } finally {
                analysisLoading.value = false
                heatmapLoading.value = false
            }
        }
    }


    const fetchScanpath = async (project, media) => {
        const mediaParams = { project, media }
        if (activeFilters.value.conditions && activeFilters.value.conditions.length > 0) {
            mediaParams.conditions = activeFilters.value.conditions
        }
        scanpathLoading.value = true
        await store
        .dispatch('app-oculis/fetchScanpath', mediaParams)
        .then(response => {
            const { data } = response
            scanpathData.value = data
            scanpathLoading.value = false

        })
        .catch(error => {
            scanpathLoading.value = false
            console.log(error)
        })
    }

    const fetchSecureMediaBlob = async (mediaUrl) => {
    try {
        
        return store
            .dispatch('app-oculis/fetchSecureMediaBlob', mediaUrl)
            .then(response => {
            const blob = response.data || response 
            // Create a local blob URL
            return URL.createObjectURL(blob)

        })
        .catch(error => {
            // store.commit('app/LOADING', false)
            console.log(error.response)
        })
        
        
    } catch (error) {
        console.error("Failed to fetch secure media blob:", error)
        return null
    } finally{

    }
}
    

    return {
        medias,
        mediaData,
        mediasLoading,
        filterLoading,
        aoiLoading,
        netLoading,
        heatmapData,
        heatmapLoading,
        analysisData,
        summaryAnalysisData,
        netAnalysisData,
        analysisLoading,
        comparisonAnalysisData,
        comparisonLoading,
        projectsData,
        projectCreationLoading,
        projectLoading,
        lighthouseProjectLoading,
        decipherProjectLoading,
        decipherProjectsData,
        oculisProjectSearch,
        projectData,
        options,
        totalProjects,
        fixationsLoading,
        elementsLoading,
        elementsOptions,
        typeItems,
        sourceItems,

        fetchAOIElements,
        fetchDecipherProjects,
        addProject,
        updateProject,
        fetchOculisProject,
        bulkCreateAOIs,
        addAOI,
        updateAOI,
        deleteAOI,
        addNet,
        updateNet,
        deleteNet,
        fetchMediaComparisonAnalysis,
        fetchMediaAnalysis,
        fetchMediaHeatmap,
        fetchMediasAOIs,
        fetchMedia,
        fetchOculisProjects,
        updateMedia,
        addMedia,
        addFixations,
        deleteFixations,
        deleteMedia,
        generateGroupId,
        downloadKPIAnalysis,
        fetchSecureMediaBlob,

        filterOptions,
        activeFilters,
        scanpathData,
        scanpathLoading,
        allCrosstabs,
        rawSegments,
        fetchFilterOptions,
        fetchScanpath,
        selectedItem,
        savedFilters,
        fetchSavedFilters,
        saveFilter,
        deleteFilter,
        renameFilter,
        applyAnalysis,
        allQuotas,

    }


}